import { Table } from "react-bootstrap";
import { Tooltip_detail as Tooltip } from "../helpers/Tooltip";
import PropTypes from "prop-types";
import { SearchSelect } from "../../forms/inputs/search-select";
import Error from "../../../../icons/ErrorIcon.svg";
import { propTypes } from "react-bootstrap/esm/Image";

export const GenericTable = ({
  data,
  columns,
  isReadonly,
  handleChange,
  setError,
  dropdownData,
  setData,
  errorStyle,
  defaultStyle,
  disableFields,
  AdditionalRow,
  combinedLabel,
  combinedOptions,
  setIsEdited,
  DataObj,
  customColumnStyle,
}) => {
  GenericTable.propTypes = {
    data: PropTypes.object,
    columns: PropTypes.array,
    isReadonly: PropTypes.bool,
    setError: PropTypes.func,
    defaultStyle: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    disableFields: PropTypes.bool,
    errorStyle: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    handleChange: PropTypes.func,
    dropdownData: PropTypes.object,
    setData: PropTypes.func,
    combinedOptions: propTypes.bool,
    combinedLabel: propTypes.string,
    setIsEdited: propTypes.func,
    customColumnStyle: propTypes.string,
  };
  console.log("tabledata1", data);
  return (
    <Table className="text-center">
      <thead>
        <tr className="border thead-color">
          {columns.map((column) => (
            <th
              key={column.header}
              className="thickness_title"
              style={{
                ...(column.width && { width: column.width }),
                ...(column.textalign && { textAlign: column.textalign }),
              }}
            >
              {column.header}
            </th>
          ))}
        </tr>
      </thead>

      <tbody>
        {data.rows.map((row, rowIndex) => (
          <tr key={rowIndex} className={row.hasError ? "border error" : "border"}>
            {columns.map((column) => {
              let key = row[column.field].field;
              let value = row[column.field].value;
              let data = dropdownData?.[column.field]?.[0] || [];
              if (column.type === "label") {
                let customColumn = "WPSSelect " + customColumnStyle;
                return (
                  <td
                    key={`${column.field}-${rowIndex}`}
                    className={customColumn}
                    style={{
                      textAlign: "left",
                      paddingLeft: "10px",
                      fontWeight: 900,
                      paddingTop: "17px",
                    }}
                  >
                    <div>
                      {row[column.field]?.value}
                      {row.hasError && row.errorMessage && (
                        <Tooltip content={row.errorMessage}>
                          <img src={Error} alt="Error" className="ms-1" />
                        </Tooltip>
                      )}
                    </div>
                  </td>
                );
              }

              if (column.type === "dropdown" || column.type === "select") {
                const selectData = column.data || data;
                return (
                  <td key={`${column.field}-dropdown-${rowIndex}`} className="WPSSelect">
                    <SearchSelect
                      required
                      data={selectData}
                      combinedOptions={combinedOptions}
                      combinedLabel={combinedLabel}
                      stylegreen={
                        row[column.field]?.error ? errorStyle : defaultStyle
                      }
                      disabled={disableFields}
                      valueField={column.valueField}
                      value={value}
                      name={key}
                      labelField={column.labelField}
                      placeholder=""
                      className={
                        row[column.field]?.error
                          ? "error-input WPSSelect"
                          : "WPSSelect"
                      }
                      onChange={(selected) => {
                        if (
                          column.customHandler &&
                          row[column.field]?.customHandler
                        ) {
                          row[column.field].customHandler(selected.value);
                        } else if (row[column.field]?.index != undefined) {
                          DataObj[row[column.field]?.index][key] =
                            selected.value;
                          setData((prevDetailObj) => {
                            const updatedDetailObj = [...prevDetailObj];
                            return updatedDetailObj;
                          });
                        } else {
                          setData((prevData) => ({
                            ...prevData,
                            [key]: selected.value,
                          }));
                        }
                        setError((prevError) => ({
                          ...prevError,
                          [key]: {},
                        }));
                        if (setIsEdited) setIsEdited(true);
                      }}
                    />
                  </td>
                );
              }

              if (column.type == "text") {
                console.log("valueeeeeeee", value);
                return (
                  <td style={row.width ? { width: column.width } : {}}>
                    {value}
                  </td>
                );
              }
              if (column.type == "ProcessInput") {
                let idx = row[column.field].index;
                let processerror = row[column.field]?.rowError;
                let processerrorfield = row[column.field]?.rowError[idx];
                return (
                  <td
                    key={`${column.field}-input-${rowIndex}`}
                    className={column.className}
                    style={{ ...(column.width && { width: column.width }) }}
                  >
                    <input
                      style={{
                        height: "38px",
                        ...(column.inputWidth && { width: column.inputWidth }),
                      }}
                      type="text"
                      className={processerrorfield?.status ? "error-input" : ""}
                      name={key}
                      maxLength={column.maxLength}
                      value={value || ""}
                      readOnly={isReadonly}
                      disabled={disableFields}
                      onChange={(e) => handleChange(e, idx)}
                      onInput={(e) => {
                        const error = column.validator
                          ? column.validator(e.target.value)
                          : null;
                        setError((prevError) => ({
                          ...prevError,
                          [key]: error,
                        }));
                        let tempError = [...processerror];
                        tempError[idx] = error;
                        row[column.field]?.setProcessError([...tempError]);
                      }}
                    />
                    <div
                      style={{
                        position: "relative",
                        top: "6px",
                        right: row[column.field]?.errorRightPosition,
                      }}
                      className={
                        processerrorfield?.status ? "d-block" : "d-none"
                      }
                    >
                      {row[column.field]?.error.status && (
                        <Tooltip
                          content={
                            row[column.field]?.error.message ||
                            processerrorfield?.message
                          }
                        >
                          <img
                            src={Error}
                            alt="Error"
                            className="ms-1 imgplace"
                          />
                        </Tooltip>
                      )}
                    </div>
                  </td>
                );
              }
              return (
                <td
                  key={`${column.field}-input-${rowIndex}`}
                  className={column.className}
                  style={{ ...(column.width && { width: column.width }) }}
                >
                  <input
                    style={{
                      height: "38px",
                      ...(column.inputWidth && { width: column.inputWidth }),
                    }}
                    type="text"
                    className={row[column.field]?.error ? "error-input" : ""}
                    name={key}
                    maxLength={column.maxLength}
                    value={value || ""}
                    readOnly={isReadonly}
                    disabled={disableFields}
                    onChange={handleChange}
                    onInput={(e) => {
                      const error = column.validator
                        ? column.validator(e.target.value)
                        : null;
                      setError((prevError) => ({
                        ...prevError,
                        [key]: error,
                      }));
                    }}
                  />
                </td>
              );
            })}
          </tr>
        ))}
        {AdditionalRow?.rows.map((row) => (
          <tr
            className={row.hasError ? "border error" : "border"}
            key={row.header}
          >
            <th
              key={row.header}
              className="text-start border thead-color Groove_green"
              style={row.width ? { width: row.width } : {}}
            >
              {row.header}
              {row.hasError && row.errorMessage && (
                <Tooltip content={row.errorMessage}>
                  <img src={Error} alt="Error" className="ms-1" />
                </Tooltip>
              )}
            </th>
            <td colSpan={row.colSpan} style={{ paddingLeft: row.padding }}>
              {row.type === "dropdown" && (
                <div style={{ width: "350px" }}>
                  <SearchSelect
                    required
                    data={
                      dropdownData[row.field] ? dropdownData[row.field][0] : []
                    }
                    stylegreen={row.error ? errorStyle : defaultStyle}
                    disabled={disableFields}
                    valueField={row.valueField}
                    combinedOptions={combinedOptions}
                    combinedLabel={combinedLabel}
                    value={row.value}
                    labelField={row.labelField}
                    placeholder=""
                    className={
                      row.error ? "error-input WPSSelect" : "WPSSelect"
                    }
                    width="350px"
                    onChange={(selected) => {
                      setData((prevData) => ({
                        ...prevData,
                        [row.field]: selected.value,
                      }));
                      setError((prevError) => ({
                        ...prevError,
                        [row.field]: {},
                      }));
                      setIsEdited(true);
                    }}
                  />
                </div>
              )}
              {row.type == "text" && <> {row.value}</>}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};
